module.exports = __webpack_public_path__ + "static/img/img-motor-color-3.e9befaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-motor-color-3.png
// module id = ClQi
// module chunks = 36